<script setup lang="ts">
import VeeCheckbox from '@/components/forms/Checkbox/VeeCheckbox.vue';
import { useTranslation } from 'i18next-vue';
import { computed } from 'vue';
import { UpdateType } from './UpdateWizard.vue';

const { t } = useTranslation();

const { type } = defineProps<{
  type: UpdateType;
}>();

const emit = defineEmits<{
  confirmed: [];
}>();

const text = computed(() => {
  switch (type) {
    case 'update':
      return {
        header: t('UpdateUpgradeInformationStepHeader'),
        backupHeader: t('UpdateUpgradeInformationStepBackupHeader'),
        backupMessage: t('UpdateInformationStepBackupMsg'),
        backupWarning: t('UpdateInformationStepBackupWarning'),
      };
    case 'upgrade':
      return {
        header: t('UpdateUpgradeInformationStepHeader'),
        backupHeader: t('UpdateUpgradeInformationStepBackupHeader'),
        backupMessage: t('UpgradeInformationStepBackupMsg'),
        backupWarning: t('UpgradeInformationStepBackupWarning'),
      };
    default:
      throw new Error(`Unknown Update Type ${type}`);
  }
});
function handleBackupConfirmation(checked: unknown) {
  if (typeof checked === 'boolean' && checked) {
    emit('confirmed');
  }
}
</script>

<template>
  <h4>{{ text.backupHeader }}</h4>
  <p>{{ text.backupMessage }}</p>

  <v-alert class="mt-5 mb-7" type="warning" :text="text.backupWarning" variant="tonal" />

  <VeeCheckbox
    class="confirm"
    name="backupConfirmed"
    :label="$t('UpgradeInformationStepBackupConfirm')"
    @change="handleBackupConfirmation"
  />
</template>

<style lang="scss">
.confirm {
  margin-bottom: 100px;
}
</style>
